import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconDefinition, faClock } from '@fortawesome/pro-solid-svg-icons';

@Component({
    selector: 'fdx-schedule-cron-viewer',
    templateUrl: './schedule-cron-viewer.component.html',
    styleUrl: './schedule-cron-viewer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ScheduleCronViewerComponent {

    @Input() cron: string = '';
    @Input() cronTimezone: string = '';

    readonly faClockIcon: IconDefinition = faClock;

}
